<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration Step 4 of 6
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <jet-form-section @submitted="saveProgress">
                    <template #title>
                        Message use cases
                    </template>

                    <template #form>


                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                    Describe the primary purpose for using text messaging for your organization<span class="required">*</span>
                                </div>
                                <div class="mb-2 font-normal">
                                    Description of what types of messages you will be sending. The more detail, the better! 
                                    <div class="font-gray italic">Minimum length must be 40 characters</div>
                                    
                                    <br /><br />
                                    <strong>Good Example</strong>: "This number is used to send out promotional offers and coupons to the customers of John’s Coffee Shop."
                                    <br /><br />

                                    <strong>Rejected Example</strong>: "Marketing"
                                    <br />

                                    <div class='italic text-gray-700'>What kind of marketing? What will the end-user/mobile handset be receiving from the end-user business?</div>
                                </div>
                            </label>
                            <textarea
                                v-model="form.campaign_description"
                                name="description"
                                placeholder="Example: We use text messaging to remind our users of upcoming appointments"
                                class="mb-3 w-full"
                                required
                            />

                        </div>

                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                   What are the types of messages you will send to your contacts? <span class="required">*</span>
                                </div>
                                <div class="font-light text-gray-600">
                                    (check all that apply)
                                </div>
                            </label>

                            <example-selectable
                                v-model="form.message_types.appointments"
                            >
                                <template #title>
                                    Appointment Reminders
                                </template>
                                <template #body>
                                    Messages to patients, customers, etc about upcoming appointments, meetings, etc.
                                </template>
                            </example-selectable>

                            <example-selectable
                                v-model="form.message_types.marketing"
                            >
                                <template #title>
                                    Marketing Messages
                                </template>
                                <template #body>
                                    Messages to customers about products or services.
                                </template>
                            </example-selectable>

                            <example-selectable
                                v-model="form.message_types.events"
                            >
                                <template #title>
                                    Event Reminders / Information
                                </template>
                                <template #body>
                                    Reminders or information regarding events.
                                </template>
                            </example-selectable>

                            <example-selectable
                                v-model="form.message_types.transactions"
                            >
                                <template #title>
                                    Transactional Notifications
                                </template>
                                <template #body>
                                    Confirmations of appointments, purchases, etc.
                                </template>
                            </example-selectable>

                            <example-selectable
                                v-model="form.message_types.services"
                            >
                                <template #title>
                                    Service Information
                                </template>
                                <template #body>
                                    Important information regarding a customer's product or service.
                                </template>
                            </example-selectable>

                        </div>


                    </template>
                    <template #actions>
                        <Link :href="route('a2p.step3')" class="mr-auto" >
                            <jet-button secondary type="button">
                                Back
                            </jet-button>
                        </Link>

                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="!goodToContinue"
                        >
                            Next
                        </jet-button>
                    </template>
                </jet-form-section>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import exampleSelectable from "../../components/A2p/ExampleSelectable";



export default {
    name: 'A2P-Step4',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        exampleSelectable,
    },
    data() {
        return {
            form: this.$inertia.form(
                {
                    _method: "POST",
                    message_types: {
                        appointments: this.$page.props.a2p.message_types.appointments ? 1 : 0,
                        marketing: this.$page.props.a2p.message_types.marketing ? 1 : 0,
                        events: this.$page.props.a2p.message_types.events ? 1 : 0,
                        transactions: this.$page.props.a2p.message_types.transactions ? 1 : 0,
                        services: this.$page.props.a2p.message_types.services ? 1 : 0,
                    },
                    campaign_description: this.$page.props.a2p.campaign_description,
                    step: 4,
                },
                {
                }
            ),
        }
    },
    computed: {
        goodToContinue() {

            if (!this.form.campaign_description || this.form.campaign_description.length < 40) {
                return false;
            }

            for (let prop in this.form.message_types) {
                if (this.form.message_types[prop])  {
                    return true;
                }
            }

            return false;
        },
       
    },
    mounted() {

    },
    methods: {
        saveProgress() {
            this.form.post("/verified/save-progress", {
                preserveScroll: true,
                onSuccess: (response) => {
                    
                },
            });
        },
    },
    watch: {
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
